import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useAuth } from "@/auth/useAuth";
import { getRuntimeConfig } from "@/config/runtimeConfig";
import { isCiamTenant } from "@/utils/tenant";

export function SignInPage() {
  const { isAuthenticated, signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const cfg = getRuntimeConfig();

  useEffect(() => {
    if (isAuthenticated) navigate("/myapps", { replace: true });
  }, [isAuthenticated, navigate]);

  const returnTo =
    (new URLSearchParams(location.search).get("returnTo") || "/myapps").trim();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-brand-50 via-white to-slate-50 p-4">
      <div className="w-full max-w-md">
        <div className="card p-8">
          <div className="mb-6 flex items-center gap-3">
            <div className="grid h-10 w-10 grid-cols-2 gap-0.5 rounded bg-brand-500 p-1.5">
              <span className="rounded-sm bg-white" />
              <span className="rounded-sm bg-white/80" />
              <span className="rounded-sm bg-white/80" />
              <span className="rounded-sm bg-white/60" />
            </div>
            <div>
              <h1 className="text-lg font-semibold text-slate-900">
                {cfg.portalTitle}
              </h1>
              <p className="text-xs text-slate-500">{cfg.companyName}</p>
            </div>
          </div>

          <h2 className="text-xl font-semibold text-slate-900">Sign in</h2>
          <p className="mt-1 text-sm text-slate-600">
            Use your{" "}
            <span className="font-medium text-slate-800">
              {isCiamTenant() ? "customer" : "organisational"}
            </span>{" "}
            account to continue to your applications.
          </p>

          <button
            type="button"
            className="btn-primary mt-6 w-full"
            onClick={() => signIn(returnTo)}
          >
            Sign in with Microsoft
          </button>

          {cfg.passwordResetUrl ? (
            <a
              href={cfg.passwordResetUrl}
              className="mt-3 block text-center text-xs font-medium text-brand-700 hover:underline"
            >
              Forgot your password?
            </a>
          ) : null}

          <p className="mt-6 text-center text-[11px] text-slate-400">
            Secured by Microsoft Entra
            {isCiamTenant() ? " External ID" : ""}.
          </p>
        </div>
      </div>
    </div>
  );
}
